import HeroSection from './components/HeroSection';
import FeaturedProperty from './components/FeaturedProperty';
import FeaturedProjects from './components/FeaturedProjects';
import Testimonials from './components/Testimonials';
import FaqSection from './components/FaqSection';

const Home = () => {
  return (
    <>
      <HeroSection />
      <FeaturedProperty />
      <FeaturedProjects />
      <Testimonials />
      <FaqSection />
    </>
  );
}

export default Home;